import { render, staticRenderFns } from "./SgTempLogin.vue?vue&type=template&id=3da46bc7&"
import script from "./SgTempLogin.vue?vue&type=script&lang=js&"
export * from "./SgTempLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports